import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYouCanDoIt = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 6.5,
		cy: 6.5,
		r: 4.72985,
		fill: "#FB5C5C",
		stroke: "#FFA7A7",
		strokeWidth: .959708
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.32812 6.65603L6.09274 8.125L8.66813 5.58984",
		stroke: "white",
		strokeWidth: .6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgYouCanDoIt;
